export const ANNOTATION_HIGHLIGHT_CLASS = 'annotation-highlight'
export const ANNOTATION_CONTEXT_LENGTH = 30
export const ANNOTATION_CONFIDENCE_THRESHOLD = 0.7
export const ANNOTATION_STABLE_DELAY = 400

export const NEAREST_WORD_THRESHOLD_PX = 12

export const PREFIX_SUFFIX_WINDOW_CHARS = 64

export const BUBBLE_OFFSET_TOP = -45

export const BUBBLE_OFFSET_LEFT = -12

export const CLICK_VS_DRAG_DISTANCE_PX = 5

export const CLICK_DURATION_MS = 300

export const OVERLAY_REDRAW_DEBOUNCE_MS = 1000

export const PAGE_SEPARATOR = '\n'

export const HIGHLIGHT_COLOR = '#ffd54f'

export const HIGHLIGHT_ALPHA = 0.25
